// Single number input with optional percent-mode rendering.
// Stored value is always raw (decimal for percentages); the input renders
// the human-friendly form (×100 for percent).
//
// One-line layout. Bigger touch target than a default input — rows hover-tint
// so the user gets feedback during long sweeps in the editor.

export default function Field({ label, value, onChange, step = 1, decimals, pct = false, suffix }) {
  const display = pct ? value * 100 : value;
  const dec = decimals != null ? decimals : pct ? 2 : step < 1 ? 2 : 0;
  return (
    <div className="px-4 py-3.5 flex items-center justify-between gap-4 hover:bg-carbon-50/60 transition-colors">
      <label className="label text-carbon-700 flex-1 leading-snug">{label}</label>
      <div className="flex items-center gap-1.5">
        <input
          type="number"
          value={Number(display.toFixed(dec))}
          step={pct ? step * 100 : step}
          onChange={(e) => {
            const raw = parseFloat(e.target.value);
            if (Number.isNaN(raw)) return;
            onChange(pct ? raw / 100 : raw);
          }}
          className="w-28 h-10 rounded-sw bg-white border border-carbon-200 px-3 text-right label num-tabular text-carbon-800 outline-none focus:border-carbon-800 focus:ring-2 focus:ring-ice-200 transition-shadow"
        />
        {pct && <span className="label text-carbon-500 w-3">%</span>}
        {suffix && !pct && <span className="label text-carbon-500">{suffix}</span>}
      </div>
    </div>
  );
}
